import { useQuery } from '@tanstack/react-query';

import { disbursementService } from '../services/disbursement.service';

export const useDisbursement = (id: string) => {
  return useQuery({
    queryKey: ['disbursement', id],
    queryFn: () => disbursementService.getDisbursement(id)
  });
};
